import LanguageSwitcher from '@/components/LanguageSwitcher/LanguageSwitcher';
import Link from '@/components/LangLink/LangLink';
import MymDropdown from '@/components/MymDropdown/MymDropdown';
import NavLabel from '@/components/NavLabel/NavLabel';
import { splitTerm } from '@/utils/splitTerm';
import { useNavigationStore } from '@/store/useNavigationStore';

function Drawer({ isOpen, onClose }) {
    const pages = useNavigationStore((s) => s.pages);
    const menuPages = pages.filter((page) => page.menu === 'yes');
    const isReady = useNavigationStore((s) => s.isReady);

    return (
        <div id="main-drawer" className={`drawer ${isOpen ? 'open' : ''}`} inert={!isOpen}>
            <LanguageSwitcher className="is-hidden-desktop mb-7" />
            <ul className="list-reset is-size-4 is-flex is-flex-direction-column gap-5">
                {isReady &&
                    menuPages.map((page) => {
                        const { primary, secondary } = splitTerm(page.term);
                        return (
                            <li key={page.section_id}>
                                <Link to={page.web_path} className="link-dn" onClick={onClose}>
                                    <NavLabel primary={primary} secondary={secondary} inline />
                                </Link>
                            </li>
                        );
                    })}
            </ul>
            <MymDropdown drawer />
        </div>
    );
}

export default Drawer;
